import React from 'react';
import Features_carousel from '../carousel/features_carousel';
import { SectionHeader } from '@apps/components/section-header';
import Testimonial_carousel from '@apps/components/carousel/testimonial_carousel';

const CardDrawer = ({title, subTitle, drawerItems}) => {
	return (
		<div>
			{/* <!-- Features --> */}
			<section className="features-section bg-[#09092C] py-12 lg:py-24 overflow-hidden">
				<div className="container relative overflow-hidden">
          <SectionHeader title={title} subTitle={subTitle} containerClass={"mx-auto mb-20 text-center"}/>

					{/* <!-- Slider --> */}
				</div>
        <div className="pl-8 relative overflow-hidden" style={{ width: '100%'}}>
          <Features_carousel drawerItems={drawerItems} />
        </div>
			</section>
			{/* <!-- end features --> */}
		</div>
	);
};

export default CardDrawer;
